import rawCountries from './rawCountries';

function createCountryObject(countries: any, value: any) {
  const countryObject: any = {};
  countries.forEach((country: any) => {
    countryObject[country] = value;
  });
  return countryObject;
}

// Filter out Jamaica from rawCountries
const countriesOtherThanJamaica = rawCountries
  .filter((country: any) => country[0] !== 'Jamaica')
  .map((country: any) => country[0]);

const countryObject = createCountryObject(countriesOtherThanJamaica, [
  ['countryNaturalizationCertificate'],
]);

export const contactUsFormConfig = {
  nextStepLabel: 'Next',
  submitButtonText: 'Submit',
  previewLabel: '',
  successIcon: 'https://i.ibb.co/RNvQN2X/success.png',
  errorIcon: 'https://i.ibb.co/GM7nsgp/icons8-error-48.png',
  fields: [
    {
      type: 'radio',
      compProps: {
        label: 'Do you have a Last Name?',
        id: 'isLastNameExist',
        direction: 'horizontal',
        options: [
          {
            label: 'Yes',
            id: 'yes',
          },
          {
            label: 'No',
            id: 'no',
          },
        ],
        required: true,
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Last Name',
        id: 'lastName',
        placeholder: 'Enter Last Name(no special characters)',
        required: true,
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'First Name',
        id: 'firstName',
        placeholder: 'Enter First Name(no special characters)',
        required: true,
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'Please Tell Us Why You Are Getting In Touch',
        id: 'reasonForContact',
        placeholder: 'Select Value',
        required: true,
        options: [
          {
            id: 'Word Permit Inquiry',
            label: 'Work Permit Inquiry',
          },
          {
            id: 'General Exemption Inquiry',
            label: 'General Exemption Inquiry',
          },
          {
            id: 'Marriage Exemption Inquiry',
            label: 'Marriage Exemption Inquiry',
          },
          {
            id: 'CSME Inquiry',
            label: 'CSME Inquiry',
          },
          {
            id: 'Rights of Establishment Inquiry',
            label: 'Rights of Establishment Inquiry',
          },
          {
            id: 'General Inquiry',
            label: 'General Inquiry',
          },
        ],
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'Can You Be More Specific?',
        id: 'specificReasonForContact',
        placeholder: 'Select Value',
        required: true,
        options: [
          {
            id: 'How long after submitting application will I get my work permit approved?',
            label:
              'How long after submitting application will I get my work permit approved?',
          },
          {
            id: 'Do I need a business registration certificate before submitting my new work permit application?',
            label:
              'Do I need a business registration certificate before submitting my new work permit application?',
          },
          {
            id: 'Can I be in the island while my new work permit application is being processed?',
            label:
              'Can I be in the island while my new work permit application is being processed?',
          },
          {
            id: 'Other',
            label: 'Other',
          },
        ],
      },
    },
    {
      type: 'select',
      compProps: {
        label: 'Tell Us More',
        id: 'tellUsMore',
        placeholder: 'Select Value',
        required: true,
        options: [
          {
            id: 'Application Status Update',
            label: 'Application Status Update',
          },
          {
            id: 'Supporting Document',
            label: 'Supporting Document',
          },
        ],
      },
    },
    {
      type: 'email',
      compProps: {
        label: 'Email Address on Account (Optional)',
        id: 'emailAddress',
        placeholder: 'example@email.com',
        required: false,
      },
    },
    {
      type: 'phoneNumber',
      compProps: {
        label: 'Phone Number (Optional)',
        id: 'phoneNumber',
        placeholder: 'Enter Phone Number',
        required: false,
      },
    },
    {
      type: 'text',
      compProps: {
        label: 'Application Reference Number (Optional)',
        id: 'applicationReferenceNumber',
        placeholder: 'NWP-1234567',
      },
    },
    {
      type: 'textarea',
      compProps: {
        rows: 5,
        label: 'Message (Optional)',
        id: 'message',
        placeholder: 'Type your message here... \n\n(max 500 characters)',
        required: false,
      },
    },
  ],
  layout: [
    ['isLastNameExist'],
    ['firstName'],
    ['reasonForContact'],
    ['specificReasonForContact'],
    ['tellUsMore'],
    ['emailAddress', 'phoneNumber'],
    ['applicationReferenceNumber'],
    ['message'],
  ],
  dynamicLayout: {
    isLastNameExist: {
      yes: [['lastName']],
    },
  },
  validatorConfig: {
    ruleSets: [
      {
        fields: {
          firstName: [
            {
              type: 'matches',
              pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
              errorMessage: 'First Name/Given Name is invalid',
            },
          ],
          lastName: [
            {
              type: 'matches',
              pattern: '^[a-zA-Z]{2,}([ ]+[a-zA-Z]+)*$',
              errorMessage: 'Last Name is invalid',
            },
          ],
        },
      },
    ],
  },
};
